// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TooltipCell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 8.25rem;
  height: 2rem;
  padding: 0 0.75rem;
  font-family: "Raleway", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  color: #21272a;
  background-color: #f2f4f8;
  cursor: default;
}
.TooltipCell .TooltipCell-Icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 1rem;
  height: 1rem;
  padding: 0;
  border: 0.5px solid #8d8279;
  background-color: #eae2da;
  color: #8d8279;
}
.TooltipCell.TooltipCell--empty {
  color: #697077;
}

.TooltipCell-Lines {
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
  white-space: nowrap;
}
.TooltipCell-Lines > li {
  padding: 0.25rem 1rem 0.25rem 0;
  line-height: 1.4;
}
.TooltipCell-Lines > li + li {
  margin-top: 0.125rem;
  border-top: 1px solid #eae2da;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/DynamicReport/components/ReportTable/components/TooltipCell/styles.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AACF;AACE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;EACA,yBAAA;EACA,cAAA;AACJ;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AADF;AAEE;EACE,+BAAA;EACA,gBAAA;AAAJ;AACI;EACE,oBAAA;EACA,6BAAA;AACN","sourcesContent":[".TooltipCell {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-width: 8.25rem;\n  height: 2rem;\n  padding: 0 0.75rem;\n  font-family: 'Raleway', sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n  color: #21272a;\n  background-color: #f2f4f8;\n  cursor: default;\n\n  .TooltipCell-Icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    width: 1rem;\n    height: 1rem;\n    padding: 0;\n    border: 0.5px solid #8d8279;\n    background-color: #eae2da;\n    color: #8d8279;\n  }\n\n  &.TooltipCell--empty {\n    color: #697077;\n  }\n}\n\n.TooltipCell-Lines {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  text-align: left;\n  white-space: nowrap;\n  > li {\n    padding: 0.25rem 1rem 0.25rem 0;\n    line-height: 1.4;\n    + li {\n      margin-top: 0.125rem;\n      border-top: 1px solid #eae2da;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
